const oneSecond = 1000;
export const NOTIFICATION_TIMEOUT = 10 * oneSecond;
export const MAX_TOAST_COUNT = 3;
export const PACKAGE_CSS_CLASS = 'realtime-notifications';
export const REALTIME_NOTIFICATIONS_TRY_ME_EVENT_NAME = 'realtime_notifications::try_me';
export const REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS = 'realtime_notifications::sound_enabled_change';
export const REALTIME_NOTIFICATIONS_REALTIME_ENABLED_CHANGE_IN_LS = 'realtime_notifications::realtime_enabled_change';
export const NOTIFICATIONS_DRAWER_LOG_MODULE = 'notification_drawer';
export const REALTIME_NOTIFICATION_LOG_MODULE = 'realtime_notifications';
export const SHARED_LOG_MODULE = 'realtime_notifications_shared';
